import type { StoreApi } from "zustand";

import type { UiState, VideoEditorState } from "../types";
import { EMPTY_UI } from "../utils";

type Set = StoreApi<VideoEditorState>["setState"];

export type UiActions = Pick<VideoEditorState, "setUi">;

export function createUiActions(set: Set): UiActions {
  return {
    setUi: (projectId, patch) => {
      set((state) => {
        const existing: UiState = state.ui[projectId] ?? EMPTY_UI;
        const next: UiState = { ...existing, ...patch };
        const openingOverlays =
          patch.activeRightPane === "overlays" || patch.selectedOverlayId != null;
        if (openingOverlays) {
          next.captionEditMode = false;
        } else if (patch.captionEditMode === true) {
          next.selectedOverlayId = null;
          if (patch.activeRightPane == null) {
            next.activeRightPane = "styles";
          }
        }
        return {
          ...state,
          ui: { ...state.ui, [projectId]: next },
        };
      });
    },
  };
}
